import styled from '@emotion/styled/macro'
import { Flex } from 'grid'
import { themeColor, themeFont } from 'mixins'
import * as React from 'react'

const StyledFlex = styled(Flex)`
  height: 100%;
  background: repeating-linear-gradient(
    ${(props: { angle?: number }) => props.angle || 45}deg,
    ${themeColor('neutralLight')},
    ${themeColor('neutralLight')} 10px,
    ${themeColor('neutralLighter')} 10px,
    ${themeColor('neutralLighter')} 20px
  );
  ${themeFont('xLarge')};
`
export interface ContentPlaceholderProps {
  gradientAngle?: number
}
export const ContentPlaceholder: React.FunctionComponent<
  ContentPlaceholderProps
> = ({ gradientAngle, children }) => (
  <StyledFlex
    angle={gradientAngle}
    flex="1"
    justifyContent="center"
    alignItems="center"
  >
    {children || 'Not yet implemented'}
  </StyledFlex>
)

export default ContentPlaceholder
